/* eslint-disable */
import { IHttpClient } from '../api';
import { AppConfig } from "@/utils/enums";
import { Notification } from "@/domain/notification";

const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

export interface NotificationResponse {
    notifications: Notification[];
}

export const NotificationApi = (http: IHttpClient) => ({
    fetchAllUnhandledNotifications: () =>
        http.get<NotificationResponse>(apiUrl + AppConfig.API_NOTIFICATIONS_URL)
            .then(response => ({
                notifications: response.data
        })),
    setNotificationHandled: (notificationId: number) =>
        http.put<any>(apiUrl + AppConfig.API_NOTIFICATIONS_URL + '/' + notificationId)
            .then(response => {
                return response
            })
});
